module.exports = __webpack_public_path__ + "zvetseni-prsou_8_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_8_after.jpg
// module id = 1369
// module chunks = 0